<template>
    <div class="project_modular">
        <div class="statistical_info">
            
            <div class="info_item" v-if="dataInfo.typeCountList" v-for="(item,index) in dataInfo.typeCountList" :key="item.projectTypeName">
                <el-image class="left_icon" v-if="item.projectType==1" src="/img/zs/zzyxmzs.png" ></el-image>
                <el-image class="left_icon" v-else-if="item.projectType==2" src="/img/zs/fwyxmzs.png"></el-image>
                <el-image class="left_icon" v-else-if="item.projectType==3" src="/img/zs/nyxmzs.png"></el-image>
                <el-image class="left_icon" v-else-if="item.projectType==4" src="/img/zs/rcxmzs.png"></el-image>
                <div class="right_all">
                    <div :class="['number','number'+index]">
                        {{item.projectTypeCount}}
                    </div>
                    <div class="label">
                        {{item.projectTypeName}}项目总数
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'statisticalInfo',
    data() {
        return {
           
        }
    },
    props: {
        dataInfo: {
            type: Object,
            default: () => {
                return {
                    typeCountList:[] 
                }
            }
        }
    },
}
</script>
<style lang="scss" scoped>
$base_width: 1920;
$base_height: 1080;

@function vw($px) {
    @return ($px / $base_width) * 100vw;
}

@function vh($px) {
    @return ($px / $base_height) * 100vh;
}

.project_modular {
    width:100%;
    height: vh(245);
    // padding: 10px ;
    display: flex;
    justify-content:center;
    align-items: center;
    .statistical_info {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width:100%;
        .info_item {
            width: 18%;
            height: 100%;
            min-width: vw(312);
            background-color: rgba(245, 245, 245, 1);
            border: none;
            border-radius: 10px;
            margin:2%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px;

            .left_icon {
                width: 60px;
                height: 60px;
                margin-right: 20px;

            }

            .right_all {
                flex: 1;
                .number {
                    font-size: 28px;
                    font-weight: 700;
                }
                .number0 {
                    color: #1296DB;
                }

                .number1 {
                    color: #FBA158;
                }

                .number2 {
                    color: #6CD188;
                }

                .number3 {
                    color: #FD7A61;
                }

                .label {
                    font-weight: 400;
                    color: #333333;
                    font-size: 16px;
                    white-space:nowrap;
                }
            }


        }
    }

}
</style>
